module.exports = __webpack_public_path__ + "img/panchito.1862cf57.png";